import React from 'react'
import { Typography } from '@material-ui/core'
import Link from '../Link/Link'
import { useAccountStyles } from './AccountStyles'
import { useTranslation } from 'react-i18next'
import Button from '../Button/Button'
import CMSText from '../Global/CMSText'

export const NoOrderBox = ({ doc }) => {
  const classes = useAccountStyles()
  const { t } = useTranslation()
  return (
    <div className={classes.main}>
      <Typography>
        <b>
          <CMSText
            asText
            data={doc?.data?.no_command}
            defaultText={t('texts:account:no_command')}
          />
        </b>
      </Typography>
      <Link href={'/shop'}>
        <a>
          <Button variant={'contained'} color={'secondary'} component="span">
            <CMSText
              asText
              data={doc?.data?.go_to_shop}
              defaultText={t('texts:account:go_to_shop')}
            />
          </Button>
        </a>
      </Link>
    </div>
  )
}
